import React from "react";
import { Link } from "react-router-dom";

import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <footer id="contact">
        <div className="contact-box d-flex justify-content-between mb-5 d-none d-md-flex">
          <div>
            <h3>Work Inquiry</h3>

            <p className="text-muted">Let's work together</p>
          </div>

          <div>
            <Link to="/contact" className="btn btn-branding">
              Contact me
            </Link>
          </div>
        </div>

        <div className="d-flex justify-content-center mb-5">
          <a href="mailto:linahmoramaga@gmail.com" className="email-link">
            linahmoramaga@gmail.com
          </a>
        </div>

        <div className="social-links d-flex justify-content-center mb-5">
          <a
            href="https://github.com/lmoramaga"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub profile"
          >
            <i className="fa-brands fa-github"></i>
          </a>

          <a
            href="https://www.linkedin.com/in/lmoramaga"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn profile"
          >
            <i className="fa-brands fa-linkedin"></i>
          </a>
        </div>
      </footer>
    </div>
  );
}
